import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { LogService } from '@shared/services';
import { SessionService } from '@shared/services/session.service';
import { StreamContentService } from '@shared/services/stream-content.service';
import { Logger } from '@unleash-tech/js-logger';
import { parse } from 'marked';
import { catchError, of } from 'rxjs';
import { BlobsService } from 'src/app/bar/services/blobs/blob.service';
import { PreviewItemModel } from '../../file-preview.component';
import { BasePreviewComponent } from '../base-preview/base-preview.component';

@UntilDestroy()
@Component({
  selector: 'md-preview',
  templateUrl: './md-preview.component.html',
  styleUrls: ['./md-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MdPreviewComponent extends BasePreviewComponent {
  html: SafeHtml;
  private logger: Logger;

  @Input() set model(model: PreviewItemModel) {
    this._model = model;
    if (!this.modelValidated()) {
      return;
    }
    try {
      this.http
        .get(model.item.srcUrl, { responseType: 'text', withCredentials: true })
        .pipe(
          untilDestroyed(this),
          catchError(() => {
            this.errorType = 'loadingError';
            this.loaded = true;
            this.cdr.markForCheck();
            return of('No Preview available');
          })
        )
        .subscribe(async (val) => {
          const p = await parse(val, { breaks: true });
          this.html = this.sanitizer.bypassSecurityTrustHtml(p);
          this.loaded = true;
          this.cdr.markForCheck();
        });
    } catch (error) {
      this.logger.error('got error while trying to fetch md file preview', error);
      throw error;
    }
  }
  get model(): PreviewItemModel {
    return this._model;
  }

  constructor(
    log: LogService,
    private http: HttpClient,
    cdr: ChangeDetectorRef,
    session: SessionService,
    private sanitizer: DomSanitizer,
    protected blobsService: BlobsService,
    protected streamContentService: StreamContentService
  ) {
    super(cdr, session, streamContentService);
    this.logger = log.scope('MdPreviewComponent');
  }
}
